import { fleetEnvironment } from '../fleet-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { vehicleGroupSchema } from '../schemas/vehicle-group.schema';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Creates an 'All Vehicles Group' for the account if it doesn't already exist. This group cannot be
 * deleted once it has been created.
 *
 * All existing and future vehicles for the account will be assigned to this group. They cannot be
 * un-assigned.
 */
export function postVehicleGroupsAllVehiclesGroup(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment.resolve(this).vehicleGroupsAllVehiclesGroupUrl}`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: vehicleGroupSchema,
        message: z.string(),
      })
    )
  );
}
